<ngb-toast *ngFor="let toast of toastService.toasts$ | async" [header]="toast.title" [autohide]="toast.autohide || false" [delay]="toast.delay || 5000" (hide)="toastService.remove(toast)" [class]="toast.type">
  <ng-template ngbToastHeader>
    <i class="fas" [class]="getToastIconClass(toast.type)"></i>
    {{ toast.title }}
  </ng-template>
  {{toast.body}}
</ngb-toast>
